var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card_box"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.index+1))]),_vm._v(" ＃"+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"data"},[_vm._v(_vm._s(_vm.talkCnt)+" 在讨论")])])
}
var staticRenderFns = []

export { render, staticRenderFns }